//removeIf(production)
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
import translation from "../../../../../../lang/es.json";
import ValidateCups from "../../../../../domain/usecases/validate-cups";
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzAlerts from "../../shared/alert/alerts.4";
import ClaroluzTypeChange from "./claroluz-type-change";
//endRemoveIf(production)

class ClaroluzValidation {
    private message: string | null = null;
    private isClick: boolean = false;
    private result: boolean = false;

    constructor() {
        this.clickEvent();
        this.checkboxClick();
        this.errorEvent();
        this.validateEvent();
    }

    private clickEvent() {
        document.querySelectorAll('.claroluz-qr-scanner-button').forEach((button: any) => {
            button.addEventListener('click', () => {
                let result = this.validate(false, true);

                if (result) {
                    new ClaroluzEventDispatch('claroluz_send_qr', {valid: result});
                    new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'event-click-qr');
                }
            });
        });

        document.querySelector('.claroluz-send-pdf')?.addEventListener('click', () => {
            let result = this.validate(false, true);

            if (result) {
                new ClaroluzEventDispatch('claroluz_send_pdf', {valid: result});
                new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'event-click-pdf');
            }            
        });

        document.querySelector('.claroluz-send-cups')?.addEventListener('click', () => {
            let result = this.validate(false, true);

            if (result) {
                new ClaroluzEventDispatch('claroluz_send_cups', {valid: result});
                new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'event-click-cups');
            }
        });
    }

    private checkboxClick() {
        document.querySelectorAll('.claroluz-uploader-checkbox').forEach((checkbox) => {
            checkbox.addEventListener('click', () => {
                this.validate(false, false);

                new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'checkbox-click');
            });
        });
    }

    private validateEvent() {
        document.addEventListener('claroluz_validate', (event: any) => {
            this.validate(false, false);

            new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'event-validate');
        });
    }

    private errorEvent() {
        document.addEventListener('claroluz_error', (event: any) => {
            this.setMessage(event.detail.message);
            this.validate(true);

            new ClaroluzEvents(appProperties(), 'uploader', 'validation', 'event-error');
        });
    }

    private validate(hasError: boolean, clickEvent: boolean = false) : boolean {
        let uploader = document.querySelector('.claroluz-uploader')!;
        this.message = this.message ?? translation.uploader.alerts.genericValidation;
        this.isClick = clickEvent;

        if (hasError === true) {
            new ClaroluzTypeChange();
            ClaroluzAlerts.show(this.message);
            return false;
        }

        if (uploader.classList.contains('type-pdf')) {
            this.validatePdf();
        } else if (uploader.classList.contains('type-cups')) {
            this.validateCups();
        } else if (uploader.classList.contains('type-qr')) {
            this.validateQrCode();
        }

        return this.result;
    }

    private setMessage(error: string) {
        switch (error) {
            case 'ERROR_QR_CODE':
                this.message = translation.uploader.qr.alerts.generic;
                break;
            case 'ERROR_CAMERA_NOT_FOUND':
                this.message = translation.uploader.qr.alerts.cameraNotFound;
                break;
            case 'CLAROLUZ_INVALID_URL':
                this.message = translation.uploader.qr.alerts.invalidUrl;
                break;
            case 'NOT_FOUND':
                this.message = translation.uploader.datasourceStatus.notFound;
                break;
            case 'BAD_REQUEST':
                this.message = translation.uploader.datasourceStatus.badRequest;
                break;
            case 'UNAUTHORIZED':
                this.message = translation.uploader.datasourceStatus.unauthorized;
                break;
            case 'FORBIDDEN':
                this.message = translation.uploader.datasourceStatus.forbidden;
                break;
            case 'INTERNAL_SERVER_ERROR':
                this.message = translation.uploader.datasourceStatus.internalServerError;
                break;
            case 'SERVICE_UNAVAILABLE':
                this.message = translation.uploader.datasourceStatus.serviceUnavailable;
                break;
            case 'GATEWAY_TIMEOUT':
                this.message = translation.uploader.datasourceStatus.gatewayTimeout;
                break;
            case 'CLAROLUZ_UNKNOWN_ERROR':
                this.message = translation.uploader.datasourceStatus.unknown;
                break;
            case 'CLAROLUZ_INVALID_PDF':
                new ClaroluzTypeChange();
                this.message = translation.uploader.datasourceStatus.invalidFile;
                break;
            case 'CLAROLUZ_INVALID_CUPS_VALUE':
                this.message = translation.uploader.datasourceStatus.invalidCups;
                break;
            case 'CLAROLUZ_INVALID_CUPS':
                this.message = translation.uploader.datasourceStatus.invalidCupsValue;
                break;
        
            default:
                this.message = error;
                break;
        }
    }

    private validateQrCode() {
        let privacy = this.privacyPolicy(this.isClick);

        if (!privacy && this.isClick) {
            this.addError();
            this.result = false;
        } else {
            this.removeError();
            this.result = true;
        }

        new ClaroluzEvents(appProperties(), 'uploader', 'validate', 'qr-code');
    }

    private validatePdf() {

        let submit: boolean = document.querySelector('.claroluz-send-pdf')!.hasAttribute('disabled');
        let isAction: boolean = this.isClick || submit;
        let dropzone = this.dropzone(isAction);
        let privacy = this.privacyPolicy(isAction);

        if (dropzone && privacy) {
            this.removeError();
            document.querySelector('.claroluz-send-pdf')!.removeAttribute('disabled');
            this.result = true;
        } else if ((!dropzone || !privacy) && isAction) {
            this.addError();
            document.querySelector('.claroluz-send-pdf')!.setAttribute('disabled', 'disabled');
            this.result = false;
        }

        new ClaroluzEvents(appProperties(), 'uploader', 'validate', 'pdf');
    }

    private validateCups() {
        let submit: boolean = document.querySelector('.claroluz-send-cups')!.hasAttribute('disabled');
        let isAction: boolean = this.isClick || submit;
        let forms = this.forms(isAction);
        let privacy = this.privacyPolicy(isAction);

        if (forms && privacy) {
            this.removeError();
            document.querySelector('.claroluz-send-cups')!.removeAttribute('disabled');
            this.result = true;
        } else if ((!forms || !privacy) && isAction) {
            this.addError();
            document.querySelector('.claroluz-send-cups')!.setAttribute('disabled', 'disabled');
            this.result = false;
        }

        new ClaroluzEvents(appProperties(), 'uploader', 'validate', 'cups');
    }

    private addError() {
        let uploader = document.querySelector('.claroluz-uploader') as HTMLElement;
        uploader.classList.add('has-error');
    }

    private removeError() {
        let uploader = document.querySelector('.claroluz-uploader') as HTMLElement;
        uploader.classList.remove('has-error');
    }

    private dropzone(action: boolean) : boolean {
        let dropzone = document.querySelector('.claroluz-uploader-pdf');

        if (dropzone) {
            let dropzoneFiles = dropzone.querySelectorAll('.dz-preview');
            let dropzoneFilesLength = dropzoneFiles.length;

            if (dropzoneFilesLength > 0 && dropzoneFilesLength <= 5) {
                ClaroluzAlerts.hide();
                return true;
            }

            if (action) {
                if (dropzoneFilesLength === 0) {
                    ClaroluzAlerts.show(translation.uploader.pdf.alerts.noFile);
                } else {
                    ClaroluzAlerts.show(translation.uploader.pdf.alerts.limit);
                }
                
            }

            return false;
        }

        ClaroluzAlerts.show(translation.uploader.pdf.alerts.dropzone);

        return false;
    }

    private forms(action: boolean) : boolean {
        let cups = document.querySelector('.cups-number') as HTMLInputElement;
        let cupsValid: boolean = false;
        let optionsValid: boolean = false;
        
        let value = document.querySelector('.cups-price') as HTMLInputElement;
        let valueValid: boolean = false;

        let valueP1 = document.querySelector('.cups-p1') as HTMLInputElement;
        let valueP1Valid: boolean = false;

        let valueP2 = document.querySelector('.cups-p2') as HTMLInputElement;
        let valueP2Valid: boolean = false;

        let valueP3 = document.querySelector('.cups-p3') as HTMLInputElement;
        let valueP3Valid: boolean = false;

        let valueMonth = document.querySelector('.cups-month') as HTMLInputElement;
        let valueMonthValid: boolean = false;

        cups.value = cups.value.trim();
        cups.value = cups.value.replace(/\s/g, '');
        if (ValidateCups.of(cups.value)) {
            cups.classList.remove('has-error');
            cupsValid = true;
        } else if (action) {
            cups.classList.add('has-error');
        }

        if (typeof parseFloat(value.value) === 'number' && parseFloat(value.value) > 0) {
            value.classList.remove('has-error');
            valueValid = true;
        } else if (action) {
            value.classList.add('has-error');
        }

        if (document.querySelector('.claroluz-cups .claroluz-action-box-content')?.classList.contains('option-1')) {
            if (typeof parseFloat(valueP1.value) === 'number' && parseFloat(valueP1.value) > 0) {
                valueP1.classList.remove('has-error');
                valueP1Valid = true;
            } else if (action) {
                valueP1.classList.add('has-error');
            }

            if (typeof parseFloat(valueP2.value) === 'number' && parseFloat(valueP2.value) > 0) {
                valueP2.classList.remove('has-error');
                valueP2Valid = true;
            } else if (action) {
                valueP2.classList.add('has-error');
            }

            if (typeof parseFloat(valueP3.value) === 'number' && parseFloat(valueP3.value) > 0) {
                valueP3.classList.remove('has-error');
                valueP3Valid = true;
            } else if (action) {
                valueP3.classList.add('has-error');
            }

            if (valueP1Valid && valueP2Valid && valueP3Valid) {
                optionsValid = true;
            }
        } else if (document.querySelector('.claroluz-cups .claroluz-action-box-content')?.classList.contains('option-2')) {
            if (typeof parseFloat(valueMonth.value) === 'number' && parseFloat(valueMonth.value) > 0 && parseFloat(valueMonth.value) <= 12) {
                valueMonth.classList.remove('has-error');
                valueMonthValid = true;
            } else if (action) {
                valueMonth.classList.add('has-error');
            }

            if (valueMonthValid) {
                optionsValid = true;
            }
            
        }
        
        if (cupsValid && valueValid && optionsValid) {
            ClaroluzAlerts.hide();
            return true;
        }

        if (action) {
            ClaroluzAlerts.show(translation.uploader.cups.alerts.inputInvalid);
        }

        return false;
    }

    private privacyPolicy(action: boolean) : boolean {
        let privacyPolicy = document.querySelector('.claroluz-uploader-checkbox .claroluz-checkbox--checkbox:checked');

        if (!privacyPolicy) {
            if (action) {
                document.querySelector('.claroluz-uploader-checkbox')?.classList.add('has-error');
            }

            return false;
        } else {
            document.querySelector('.claroluz-uploader-checkbox')?.classList.remove('has-error');
        }

        return true;
    }
}

//removeIf(production)
export default ClaroluzValidation;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)